/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MessageListResponse } from '../../models/message-list-response';

export interface GetCriticalMessages$Params {

/**
 * Filter out not acknowledged messages
 */
  acknowledged?: boolean | null;
}

export function getCriticalMessages(http: HttpClient, rootUrl: string, params?: GetCriticalMessages$Params, context?: HttpContext): Observable<StrictHttpResponse<MessageListResponse>> {
  const rb = new RequestBuilder(rootUrl, getCriticalMessages.PATH, 'get');
  if (params) {
    rb.query('acknowledged', params.acknowledged, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MessageListResponse>;
    })
  );
}

getCriticalMessages.PATH = '/api/v1/critical_messages';
